import React from 'react';
import { APP_SHORT_NAME } from '../../../constants/branding';

interface ReportHeaderProps {
  reportTitle: string;
  reportSubtitle?: string;
  dateRange: { from: string; to: string };
  donationTypes: string[];
  colorScheme?: string;
  showLogo?: boolean;
  headerImageUrl?: string;
}

const COLORS: Record<string, { primary: string; accent: string; bg: string }> = {
  default:   { primary: '#1a5276', accent: '#d4af37', bg: '#eaf2f8' },
  grayscale: { primary: '#2c3e50', accent: '#95a5a6', bg: '#ecf0f1' },
  green:     { primary: '#1e8449', accent: '#d4af37', bg: '#e8f8f5' },
  blue:      { primary: '#1f3a5f', accent: '#d4af37', bg: '#dbeafe' },
};

const ReportHeader: React.FC<ReportHeaderProps> = ({
  reportTitle,
  reportSubtitle,
  dateRange,
  donationTypes,
  colorScheme = 'default',
  showLogo = false,
  headerImageUrl,
}) => {
  const c = COLORS[colorScheme] || COLORS.default;
  const formatD = (d: string) => { try { return new Date(d).toLocaleDateString('en-GB'); } catch { return d; } };
  const logoSrc = showLogo && headerImageUrl ? headerImageUrl : null;

  return (
    <div className="rounded-t-xl overflow-hidden border border-gray-200 dark:border-gray-700" style={{ borderColor: c.accent }}>
      <div className="h-1" style={{ background: `linear-gradient(90deg, ${c.accent}, ${c.primary}, ${c.accent})` }} />

      <div className="px-6 py-4 text-center" style={{ backgroundColor: c.bg + '40' }}>
        {logoSrc && (
          <div className="flex justify-center mb-2">
            <img
              src={logoSrc}
              alt="Organization logo"
              className="h-14 w-14 object-contain"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
          </div>
        )}

        <p className="text-lg font-semibold mb-0.5" style={{ color: c.primary, fontFamily: "'Noto Naskh Arabic', serif", direction: 'rtl' }}>
          حزب الرحمٰن اسلامک اکیڈمی
        </p>
        <h2 className="text-xl font-bold tracking-wide" style={{ color: c.primary }}>
          {APP_SHORT_NAME}
        </h2>

        <div className="w-40 h-px mx-auto my-2" style={{ backgroundColor: c.accent }} />

        <h3 className="text-base font-bold text-gray-800 dark:text-gray-200">{reportTitle}</h3>
        {reportSubtitle && <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{reportSubtitle}</p>}

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-2 text-xs text-gray-500 dark:text-gray-400">
          <span>Period: {formatD(dateRange.from)} — {formatD(dateRange.to)}</span>
          {donationTypes.length > 0 && <span>Fund Type(s): {donationTypes.join(', ')}</span>}
          <span>Generated: {new Date().toLocaleDateString('en-GB')}</span>
        </div>
      </div>

      <div className="h-0.5" style={{ backgroundColor: c.primary }} />
    </div>
  );
};

export default ReportHeader;
